export default __webpack_public_path__ + "static/3-f600e95d21c2884fd06052b6941a1d07.gif";